import { combineReducers } from "redux";
import { user } from "./user";
import { msg } from "./msg";
import { room } from "./room";


export const reducers = combineReducers({
     user , msg, room,
})

